import { atom } from "jotai";

export const socketAtom = atom<any>(null);
